import script from "./AssetDetailInfoContentEditable.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetDetailInfoContentEditable.vue?vue&type=script&setup=true&lang=ts"

import "./AssetDetailInfoContentEditable.vue?vue&type=style&index=0&id=0f481820&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f481820"]])

export default __exports__